import React from 'react';

import { useFinanceFilter } from '@/hooks/filters/finance-filter.hook';

import { SectionName } from '../section-name/section-name';
import { Term } from '../term/term';

import styles from './payment-term.module.scss';

export const PaymentTerm: React.FC = () => {
  const paymentTerms = [12, 24, 36, 48, 60, 72];
  const { financeFilter, setFinanceFilter } = useFinanceFilter();
  const { paymentTerm } = financeFilter;

  return (
    <div>
      <div className={styles.sectionNameWrapper}>
        <SectionName>Payment Term</SectionName>
      </div>
      <div className={styles.paymentTermsWrapper}>
        {paymentTerms.map((term) => (
          <Term
            key={term}
            term={term}
            selectedTerm={paymentTerm}
            onClick={() =>
              setFinanceFilter((prevState) => ({
                ...prevState,
                paymentTerm: term,
              }))
            }
          />
        ))}
      </div>
    </div>
  );
};
